<template>
  <div class="scroll-vertical full-height big-spacer related-users">
    <div v-for="user in users" :key="user.uid" class="spacer">
      <alert-log-user :user="user" :related="related"></alert-log-user>
    </div>
  </div>
</template>

<script>
import AlertLogUser from '@/components/alertlogs/AlertLogUser.vue';

export default {
  name: 'AlertRelatedUsers',
  components: {
    AlertLogUser,
  },
  props: {
    users: {
      type: Array,
      required: true,
    },
    related: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.spacer {
  margin-bottom: 1rem;
}

.big-spacer {
  padding-bottom: 8rem;
}

.full-height {
  height: 100%;
}
</style>
